import styled from "@emotion/styled";
import { fontRoboto, theme } from "@product/scmp-sdk";

import { BaseLink } from "shared/components/common/base-link";
import { setFullViewportWidthStyles } from "shared/lib/styles";

import { AppFooter } from "scmp-app/components/app-footer";
import { MobileNewsletterPreview } from "scmp-app/components/newsletter/mobile-newsletter-preview";
import { NewsletterCategorySlideshow } from "scmp-app/components/newsletter/newsletter-category-item-slideshow";
import { List } from "scmp-app/components/newsletter/newsletter-category-item-slideshow/styles";
import { NewsletterDetails } from "scmp-app/components/newsletter/newsletter-details";
import { NewsletterPreview } from "scmp-app/components/newsletter/newsletter-list/newsletter-preview";

export const Container = styled.div`
  display: none;
  justify-content: center;

  ${theme.breakpoints.up("tablet")} {
    display: flex;
  }
`;

export const StyledNewsletterCategorySlideshow = styled(NewsletterCategorySlideshow)`
  grid-area: NewsletterCategorySlideshow;

  display: flex;
  flex-direction: column;

  inline-size: 100%;

  ${theme.breakpoints.down("tablet")} {
    ${List} {
      margin-inline: 20px 0;
      ${setFullViewportWidthStyles()}
    }
    .swiper-slide {
      margin-inline-start: 20px;
      &:first-child {
        margin-inline-start: 20px;
      }
    }
  }
`;

export const Wrapper = styled.div`
  display: grid;
  grid-template:
    "Details Preview" min-content
    "NewsletterCategorySlideshow NewsletterCategorySlideshow" min-content
    / 1fr 1fr;
  gap: 60px 40px;
  justify-content: center;

  /* stylelint-disable-next-line csstree/validator */
  max-inline-size: min(calc(100vw - 32px), 768px);
  margin-block: 40px;

  ${StyledNewsletterCategorySlideshow} {
    .swiper {
      /* stylelint-disable-next-line csstree/validator */
      max-inline-size: min(calc(100vw - 32px), 768px);
    }
  }
`;

export const Preview = styled(NewsletterPreview)`
  grid-area: Preview;
`;

export const StyledNewsletterDetails = styled(NewsletterDetails)`
  grid-area: Details;
`;

export const DetailsHeader = styled(BaseLink)`
  display: flex;
  gap: 12px;
  align-items: center;

  color: #000000;
  font-weight: 400;
  font-size: 14px;
  font-family: ${fontRoboto};
  font-style: normal;
  line-height: normal;
  font-feature-settings:
    "liga" off,
    "clig" off;
`;

export const StyledMobileNewsletterPreview = styled(MobileNewsletterPreview)`
  ${setFullViewportWidthStyles()}

  ${theme.breakpoints.up("tablet")} {
    display: none;
  }
`;

export const StyledAppFooter = styled(AppFooter)`
  display: none;

  ${theme.breakpoints.up("tablet")} {
    display: flex;
  }
`;
